import { Radio } from "element-ui";
import FormBase from "./FormBase";
export default {
  name: "AceRadio",
  //extends: Radio,
  mixins: [Radio, FormBase],
  data() {
    return {
      isAuth: true,
    };
  },
  computed: {
    isDisabled() {
      return this.isGroup
        ? this._radioGroup.groupDisabled || this.disabled || (this.elForm || {}).disabled || !this.isAuth
        : this.disabled || (this.elForm || {}).disabled || this.isOperationDisabled() || !this.isAuth;
    },
  },
};
